import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Theme } from '../model/theme';

const THEME = 'theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(private deviceService: DeviceDetectorService) {}

  public getTheme() {
    const theme = window.localStorage.getItem(THEME);
    if (theme) {
      return JSON.parse(theme) == 0 ? 'white-theme' : 'black-theme';
    }
    return Theme.whiteTheme == 0 ? 'white-theme' : 'black-theme';
  }

  public getDeviceClass() {
    if (this.deviceService.isMobile()) {
      return 'mobile';
    } else if (this.deviceService.isTablet()) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  public getCombinedClasses() {
    return `${this.getTheme()} ${this.getDeviceClass()}`;
  }

  public changeTheme() {
    const newTheme = this.getTheme() == 'white-theme' ? Theme.blackTheme : Theme.whiteTheme;
    window.localStorage.setItem(THEME, JSON.stringify(newTheme));
  }
}
